import React from 'react';
import I18n from 'i18n-js';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

import { findProductFamilySpec, shouldDisplayProductFamilyLink } from '@reverbdotcom/commons/src/product_family_helpers';
import dotMatrixPattern from '../../images/dot_matrix_pattern.jpg';
import { core_apimessages_ProductSpec } from '../schemas/rql';

// README
// This is using 100% utility classes which seems to work but the main gotcha is
// no style overrides for i2 and CSP contexts (the image gets a little wonky in each case)

// I didn't have mobile designs to go off of, so we'll need to add those later and/or port
// this over to a stylesheet where we can target specific contexts if necessary

interface IProps {
  wrappingClassName?: string;
  productSpecs: core_apimessages_ProductSpec[];
  thumbnailImage: string;
}

export function ProductFamilyCTA(props: IProps) {
  const mparticleEvent: MParticleEvent = {
    componentName: 'ProductFamilyCTA',
    eventName: MParticleEventName.ComponentView,
  };

  const productFamily = findProductFamilySpec(props.productSpecs);

  // track a component view if a product family exists
  const shouldTrack = !!productFamily;
  useViewTracking(mparticleEvent, shouldTrack);

  const shouldDisplay = shouldDisplayProductFamilyLink(props.productSpecs);

  if (!shouldDisplay) {
    return null;
  }

  const clickEvent = {
    eventName: MParticleEventName.ClickedComponent,
    componentName: 'ProductFamilyCTA',
    entityType: 'url',
    entityId: productFamily.path,
  };

  const cta = (
    <div
      className="bd-1 bd-primary"
      style={{
        backgroundImage: `url(${dotMatrixPattern})`,
        backgroundSize: 'cover',
        backgroundPosition: 'right center',
      }}
    >
      <div className="d-flex">
        <div className="width-20 bdr-1 bd-primary bg-white d-flex fx-align-center">
          <div className="image-box">
            <CoreLink
              to={productFamily.path}
              clickEvent={clickEvent}
              target="_top"
            >
              <img
                className="d-block"
                src={props.thumbnailImage}
                alt={productFamily.value}
              />
            </CoreLink>
          </div>
        </div>
        <div className="fx-grow pl-4 pr-2 ptb-3 d-flex fx-align-center fx-wrap fx-justify-between">
          <div className="d-flex fx-dir-col mtb-half mr-2">
            <CoreLink
              className="color-gray"
              to={productFamily.path}
              clickEvent={clickEvent}
              target="_top"
            >
              <h4 className="size-140">{productFamily.value}</h4>
            </CoreLink>
            <p className="mb-0">
              {I18n.t('discovery.productFamilyCTA.deals')}
            </p>
          </div>
          <CoreLink
            className="button button--primary mtb-half mr-2"
            to={productFamily.path}
            clickEvent={clickEvent}
            target="_top"
          >
            {I18n.t('discovery.productFamilyCTA.seeMore')}
          </CoreLink>
        </div>
      </div>
    </div>
  );

  if (!props.wrappingClassName) {
    return cta;
  }

  return <div className={props.wrappingClassName}>{cta}</div>;
}
